import Helpers from "commons/helpers";
import Constants from "constants/index";
import MedkitService from "./medkit.service";
import { IRecordProjectMember, IResponseGetPaged } from "commons/interfaces";

class ProjectMemberService extends MedkitService {

    public getPaged = async (data: {
        projectId?: string;
        searchText?: string;
        pageNumber?: number;
        pageSize?: number;
        orderby?: string;
    }): Promise<IResponseGetPaged<IRecordProjectMember>> => {
        const query = Helpers.handleFormatParams(data);
        const result = await this.api.get({
            path: Constants.ApiPath.PROJECT_MEMBER.GET_PAGED + `${query ? "?" : ""}${query}`
        });
        return result.data.result;
    };

    public getByCondition = async (data: {
        userId?: string;
        projectId?: string;
        searchText?: string;
    }): Promise<IRecordProjectMember[]> => {
        const query = Helpers.handleFormatParams(data);
        const result = await this.api.get({
            path: Constants.ApiPath.PROJECT_MEMBER.GET_BY_CONDITION + `${query ? "?" : ""}${query}`
        });
        return result.data.result;
    };

    public create = async (data: {
        userId: string,
        projectId: string,
    }) => {
        const result = await this.api.post({
            path: Constants.ApiPath.PROJECT_MEMBER.CREATE,
            data: data,
        });
        return result.data.result;
    };

    public delete = async (id: string) => {
        const result = await this.api.delete({
            path: Constants.ApiPath.PROJECT_MEMBER.DELETE + `/${id}`
        });
        return result.data.result;
    };

};

export default ProjectMemberService;